import { gql } from "@apollo/client";

export const REFERENCES_QUERY = gql`
  query references($scenarioId: ID!, $originId: ID) {
    data(scenarioId: $scenarioId, originId: $originId) {
      references {
        items {
          id
          value
          referenceCategoryId
          enabled
          referenceCategory {
            id
            code
            name
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
          __typename
        }
      }
    }
  }
`;
